import { createAction } from 'redux-actions';
import axios from 'axios';
import routes from '../routes';

// eslint-disable-next-line import/prefer-default-export
export const setCorrectData = createAction('CORRECT_DATA_SET');
export const setFormValues = createAction('FORM_VALUES_SET');
export const setSslCheck = createAction('SSL_CHECK_SET');

export const sendDataRequest = createAction('DATA_SEND_REQUEST');
export const sendDataSuccess = createAction('DATA_SEND_SUCCESS');
export const sendDataFailure = createAction('DATA_SEND_FAILURE');

export const setForm = createAction('FORM_SET');

export const getTokenStRequest = createAction('TOKEN_SEND_REQUEST');
export const getTokenStSuccess = createAction('TOKEN_SEND_SUCCESS');
export const getTokenStFailure = createAction('TOKEN_SEND_FAILURE');

export const sendVerifyRequest = createAction('VERIFY_SEND_REQUEST');
export const sendVerifySuccess = createAction('VERIFY_SEND_SUCCESS');
export const sendVerifyFailure = createAction('VERIFY_SEND_FAILURE');

export const sendData = data => (dispatch) => {
  dispatch(sendDataRequest());
  const url = routes.syncUrl();
  axios.post(url, data)
    .then((response) => {
      console.log(response);
      dispatch(sendDataSuccess({ responseLink: response.data.responseLink, message: response.data.message, responseToken: response.data.responseToken }));
    })
    .catch((err) => {
      console.log(err);
      dispatch(sendDataFailure({ responseError: 'errore del request' }));
    });
};


export const sendVerifyData = data => (dispatch) => {
  dispatch(sendVerifyRequest());
  axios.post(routes.testUrl(), data)
    .then((response) => {
      const correctData = response.data;
      const state = correctData ? 'correct' : 'incorrect';
      dispatch(sendVerifySuccess({ correctDataState: state }));
    })
    .catch(() => {
      dispatch(sendVerifyFailure({ responseError: 'errore del request' }));
    });
};

export const getTokenSt = token => (dispatch) => {
  dispatch(getTokenStRequest());
  const url = routes.tokenUrl(token);
  axios.get(url, token)
    .then((response) => {
      const state = response.data;
      dispatch(getTokenStSuccess({ tokenState: state }));
    })
    .catch(() => {
      dispatch(getTokenStFailure({ responseError: 'errore del request' }));
    });
};
